import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const RatingStars = ({ rating, count, onRate, interactive = false }) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            disabled={!interactive}
            onClick={() => onRate && onRate(star)}
            className={`transition-all ${interactive ? 'hover:scale-110 active:scale-90' : 'cursor-default'}`}
          >
            <SafeIcon
              icon={FiStar}
              className={`text-sm ${
                star <= rating 
                  ? 'fill-amber-400 text-amber-400' 
                  : 'text-slate-200'
              }`}
            />
          </button>
        ))}
      </div>
      {count !== undefined && (
        <span className="text-[10px] font-black text-slate-400 uppercase tracking-tighter">
          ({count} reviews)
        </span>
      )}
    </div>
  );
};

export default RatingStars;